import { useEffect, useState } from "react";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const UPDATE_MODAL = "UPDATE_MODAL";
export const TOGGLE_MODAL = "TOGGLE_MODAL";

const initialState = {
    state: CLOSE_MODAL,
    variant: "default",
    title: "",
    buttons: [],
    didProvideButtons: false,
    onConfirm: () => {
        dispatch({ type: CLOSE_MODAL });
    },
    onCancel: () => {
        dispatch({ type: CLOSE_MODAL });
    },
    children: null,
    disabled: false,
};

export const reducer = (oldState, action) => {
    switch (action.type) {
        case OPEN_MODAL:
            return Object.assign({}, oldState, {
                state: OPEN_MODAL,
                ...action.payload,
            });
        case CLOSE_MODAL:
            return Object.assign({}, oldState, {
                state: CLOSE_MODAL,
                ...action.payload,
            });
        case UPDATE_MODAL:
            return Object.assign({}, oldState, {
                state: OPEN_MODAL,
                ...action.payload,
            });
        case TOGGLE_MODAL:
        default:
            return Object.assign({}, oldState, {
                state: oldState.state === OPEN_MODAL ? CLOSE_MODAL : OPEN_MODAL,
                ...action.payload,
            });
    }
};

const listeners = [];
let memState = initialState;
export const dispatch = (action) => {
    memState = reducer(memState, action);
    listeners.forEach((listener) => {
        listener(memState);
    });
};

export const useStore = () => {
    const [state, setState] = useState(memState);
    useEffect(() => {
        listeners.push(setState);
        return () => {
            const index = listeners.indexOf(setState);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    }, [state]);

    return state;
};
